import { render, staticRenderFns } from "./service-select.vue?vue&type=template&id=36499371"
import script from "./service-select.vue?vue&type=script&lang=js"
export * from "./service-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports